// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"1563e052","199":"1563e052","2533":"1563e052","5004":"1563e052","5923":"822989d6"}[chunkId] + ".chunk.css";
};